import {
    ADD_EMPLOYEE,
    EDIT_EMPLOYEE,
    DELETE_EMPLOYEE,
    FETCH_EMPLOYEES,
    ADD_PREMISES,
    EDIT_PREMISES,
    DELETE_PREMISES,
    FETCH_PREMISES_LIST,
    ADD_CONSULTANT,
    EDIT_CONSULTANT,
    DELETE_CONSULTANT,
    FETCH_CONSULTANTS,
    ADD_PURCHASE,
    EDIT_PURCHASE,
    DELETE_PURCHASE,
    FETCH_PURCHASES,
    ADD_LEASING,
    EDIT_LEASING,
    DELETE_LEASING,
    FETCH_LEASINGS,
    ADD_RENTAL,
    EDIT_RENTAL,
    DELETE_RENTAL,
    FETCH_RENTALS,
    ADD_MATERIAL,
    EDIT_MATERIAL,
    DELETE_MATERIAL,
    FETCH_MATERIALS,
    ADD_PRODUCTION_VOLUME,
    EDIT_PRODUCTION_VOLUME,
    DELETE_PRODUCTION_VOLUME,
    FETCH_PRODUCTION_VOLUMES,
    ADD_LOAN,
    EDIT_LOAN,
    DELETE_LOAN,
    FETCH_LOANS,
    ADD_DIGITAL_AD,
    EDIT_DIGITAL_AD,
    DELETE_DIGITAL_AD,
    FETCH_DIGITAL_ADS,
    ADD_EVENT,
    EDIT_EVENT,
    DELETE_EVENT,
    FETCH_EVENTS,
    ADD_MARKET_RESEARCH,
    EDIT_MARKET_RESEARCH,
    DELETE_MARKET_RESEARCH,
    FETCH_MARKET_RESEARCH,
    FETCH_COST_REPORT,
    FETCH_COST_REPORT_DETAILED,
    ADD_BRANDING_PROJECT,
    EDIT_BRANDING_PROJECT,
    DELETE_BRANDING_PROJECT,
    FETCH_BRANDING_PROJECTS,
    ADD_SERVICE,
    EDIT_SERVICE,
    DELETE_SERVICE,
    FETCH_SERVICES
} from './types';
import { postAction, deleteAction, getAction } from './actionFunctions';

export const addEmployee = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=employee', ADD_EMPLOYEE, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getEmployees = () => async dispatch => {
    await getAction('/api/cost/get_items?type=employee', FETCH_EMPLOYEES, dispatch)
};

export const editEmployee = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=employee', EDIT_EMPLOYEE, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteEmployee = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'employee'}`, DELETE_EMPLOYEE, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addPremises = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=premises', ADD_PREMISES, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getPremisesList = () => async dispatch => {
    await getAction('/api/cost/get_items?type=premises', FETCH_PREMISES_LIST, dispatch)
};

export const editPremises = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=premises', EDIT_PREMISES, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deletePremises = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'premises'}`, DELETE_PREMISES, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addConsultant = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=consultant', ADD_CONSULTANT, formValues, dispatch)
    
    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getConsultants = () => async dispatch => {
    await getAction('/api/cost/get_items?type=consultant', FETCH_CONSULTANTS, dispatch)
};

export const editConsultant = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=consultant', EDIT_CONSULTANT, formValues, dispatch)
    
    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteConsultant = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'consultant'}`, DELETE_CONSULTANT, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addPurchase = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=purchase', ADD_PURCHASE, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getPurchases = () => async dispatch => {
    await getAction('/api/cost/get_items?type=purchase', FETCH_PURCHASES, dispatch)
};

export const editPurchase = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=purchase', EDIT_PURCHASE, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deletePurchase = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'purchase'}`, DELETE_PURCHASE, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addLeasing = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=leasing', ADD_LEASING, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getLeasings = () => async dispatch => {
    await getAction('/api/cost/get_items?type=leasing', FETCH_LEASINGS, dispatch)
};

export const editLeasing = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=leasing', EDIT_LEASING, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteLeasing = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'leasing'}`, DELETE_LEASING, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addRental = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=rental', ADD_RENTAL, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getRentals = () => async dispatch => {
    await getAction('/api/cost/get_items?type=rental', FETCH_RENTALS, dispatch)
};

export const editRental = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=rental', EDIT_RENTAL, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteRental = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'rental'}`, DELETE_RENTAL, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addMaterial = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=material', ADD_MATERIAL, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getMaterials = () => async dispatch => {
    await getAction('/api/cost/get_items?type=material', FETCH_MATERIALS, dispatch)
};

export const editMaterial = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=material', EDIT_MATERIAL, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteMaterial = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'material'}`, DELETE_MATERIAL, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addVolume = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=volume', ADD_PRODUCTION_VOLUME, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getVolumes = () => async dispatch => {
    await getAction('/api/cost/get_items?type=volume', FETCH_PRODUCTION_VOLUMES, dispatch)
};

export const editVolume = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=volume', EDIT_PRODUCTION_VOLUME, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteVolume = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'volume'}`, DELETE_PRODUCTION_VOLUME, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const addLoan = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=loan', ADD_LOAN, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const editLoan = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=loan', EDIT_LOAN, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteLoan = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'loan'}`, DELETE_LOAN, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getLoans = () => async dispatch => {
    await getAction('/api/cost/get_items?type=loan', FETCH_LOANS, dispatch)
};

export const addDigitalAd = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=digital_ad', ADD_DIGITAL_AD, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const editDigitalAd = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=digital_ad', EDIT_DIGITAL_AD, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteDigitalAd = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'digital_ad'}`, DELETE_DIGITAL_AD, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getDigitalAds = () => async dispatch => {
    await getAction('/api/cost/get_items?type=digital_ad', FETCH_DIGITAL_ADS, dispatch)
};

export const addEvent = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=event', ADD_EVENT, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const editEvent = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=event', EDIT_EVENT, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteEvent = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'event'}`, DELETE_EVENT, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getEvents = () => async dispatch => {
    await getAction('/api/cost/get_items?type=event', FETCH_EVENTS, dispatch)
};

export const addMarketResearch = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=market_research', ADD_MARKET_RESEARCH, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const editMarketResearch = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=market_research', EDIT_MARKET_RESEARCH, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteMarketResearch = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'market_research'}`, DELETE_MARKET_RESEARCH, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getMarketResearch = () => async dispatch => {
    await getAction('/api/cost/get_items?type=market_research', FETCH_MARKET_RESEARCH, dispatch)
};

export const addBranding = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=branding', ADD_BRANDING_PROJECT, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const editBranding = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=branding', EDIT_BRANDING_PROJECT, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteBranding = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'branding'}`, DELETE_BRANDING_PROJECT, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getBrandings = () => async dispatch => {
    await getAction('/api/cost/get_items?type=branding', FETCH_BRANDING_PROJECTS, dispatch)
};

export const addService = (formValues) => async dispatch => {
    await postAction('/api/cost/add_item?type=service', ADD_SERVICE, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const editService = (formValues) => async dispatch => {
    await postAction('/api/cost/update_item?type=service', EDIT_SERVICE, formValues, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const deleteService = (id) => async dispatch => {
    await deleteAction(`/api/cost/delete_item?id=${id}&type=${'service'}`, DELETE_SERVICE, dispatch)

    dispatch(getCostReport())
    dispatch(getCostReportDetailed())
};

export const getServices = () => async dispatch => {
    await getAction('/api/cost/get_items?type=service', FETCH_SERVICES, dispatch)
};

export const getCostReport = () => async dispatch => {
    await getAction('/api/cost/cost_report', FETCH_COST_REPORT, dispatch)
};

export const getCostReportDetailed = () => async dispatch => {
    await getAction('/api/cost/cost_report_detailed', FETCH_COST_REPORT_DETAILED, dispatch)
};